import { initDatadog } from '@pesto/features';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './index.css';
import { ApolloProviderWrapper } from './providers/Apollo';

initDatadog({
  applicationId: 'dc0342b4-c2af-4562-a9f9-34c185e84a99',
  clientToken: 'pub7b658bd6acac38fb6e08fb3a161b9242',
  service: 'mission-control',
  env: import.meta.env.VITE_ENV ?? 'local',
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ApolloProviderWrapper>
        <App />
      </ApolloProviderWrapper>
    </BrowserRouter>
  </StrictMode>,
);
